export const SUBSCRIPTION_QUERY_KEY = {
  CUSTOMER: 'account_module.subscription.customer',
  PRODUCTS: 'account_module.subscription.products',
  PRICES: 'account_module.subscription.prices',
};
